<template>
  <table class="authenticatorsTableContainer table">
    <thead>
      <tr>
        <td class="text-left font-weight-bold text-warning font-size-12">
          <div class="flex-start-end">
            COMPARE FEATURED SERVICES
          </div>
        </td>
        <td>
          <div class="iconWrapper h-100 flex-center">
            <Cgc fill="#000" width="90px" />
          </div>
        </td>
        <td>
          <div class="iconWrapper h-100 flex-center">
            <Cgc fill="#000" width="90px" />
          </div>
        </td>
        <td class="bg-lighter">
          <div class="iconWrapper h-100 flex-center">
            <Sgc fill="#000" height="27px" width="68px" />
          </div>
        </td>
        <td>
          <div class="iconWrapper h-100 flex-center">
            <Beckett fill="#000" height="24px" width="90px" />
          </div>
        </td>
        <td class="bg-lighter">
          <div class="iconWrapper h-100 flex-center">
            <PSALogo width="90px" />
          </div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="{label, values} in authenticatorsTableData"
        :key="label"
      >
        <td>
          <div class="flex-start-center font-weight-bold text-dark text-left">
            {{ label }}
          </div>
        </td>
        <td
          v-for="(strings, index) in values"
          :key="index"
          :class="index % 2 !== 0 ? 'bg-white' : 'bg-lighter'"
        >
          <div class="flex-col-center">
            <span
              v-for="value in strings"
              :key="value"
              class="text-corduroy"
            >
              {{ value }}
            </span>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { authenticatorsTableData } from '../constants/authenticatorsConstants';
import { Beckett, Cgc, Sgc, PSALogo } from '@js/web/components/icons';

export default {
  name: 'AuthenticatorsTable',
  components: {
    Beckett,
    Cgc,
    Sgc,
    PSALogo
  },
  data() {
    return {
      authenticatorsTableData
    };
  }
};
</script>

<style lang="scss">
.authenticatorsTableContainer {
  height: 1px; //sets a height on the table that allows cells to inherit from. actual value is ignored

  thead {
    tr {
      height: 107px;
      &:first-of-type {
        td {
          border-top: none;
        }
      }
      td {
        height: 100%;
        width: 14%;

        &:first-of-type {
          width: 28%;
        }
        > div {
          height: 100%;
        }
      }
    }
  }
  tbody {
    tr {
      height: 64px;
      td {
        height: 100%;
        > div {
          height: 100%;
        }
      }
    }
  }
}
</style>
